import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  CompleteRecoveringRequestModel,
  ForgotPasswordModel,
  LoginModel,
  RegistrationModel,
} from '@/core/services/Auth/models/AuthModel'
import { ChangePasswordModel } from '@/modules/AccountPage/models/UserModel'
import AuthService from '@/core/services/Auth/AuthService'

export const loginThunk = createAsyncThunk(
  'auth/loginThunk',
  async (data: LoginModel, { rejectWithValue }) => {
    try {
      return await AuthService.login(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const forgotPasswordThunk = createAsyncThunk(
  'auth/forgotPasswordThunk',
  async (email: ForgotPasswordModel, { rejectWithValue }) => {
    try {
      return await AuthService.forgotPassword(email)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const registrationThunk = createAsyncThunk(
  'auth/registrationThunk',
  async (data: RegistrationModel, { rejectWithValue }) => {
    try {
      return await AuthService.registration(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const changePasswordThunk = createAsyncThunk(
  'auth/changePasswordThunk',
  async (data: ChangePasswordModel, { rejectWithValue }) => {
    try {
      return await AuthService.changePassword(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const completeRecoveringPasswordThunk = createAsyncThunk(
  'auth/completeRecoveringPasswordThunk',
  async (data: CompleteRecoveringRequestModel, { rejectWithValue }) => {
    try {
      return await AuthService.completeRecoveringPassword(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const authSlice = createSlice({
  name: 'auth',
  initialState: null,
  reducers: {},
})

export const { actions, reducer } = authSlice
